enum Types {
  GET_ALL_CLIENTS_REQUEST = 'GET_ALL_CLIENTS_REQUEST',
  GET_ALL_CLIENTS_FULFILLED = 'GET_ALL_CLIENTS_FULFILLED',
  GET_ALL_CLIENTS_REJECTED = 'GET_ALL_CLIENTS_REJECTED',

  GET_ALL_CLIENTS_OPERATOR_REQUEST = 'GET_ALL_CLIENTS_OPERATOR_REQUEST',
  GET_ALL_CLIENTS_OPERATOR_FULFILLED = 'GET_ALL_CLIENTS_OPERATOR_FULFILLED',
  GET_ALL_CLIENTS_OPERATOR_REJECTED = 'GET_ALL_CLIENTS_OPERATOR_REJECTED',

  GET_HISTORY_SESSIONS_REQUEST = 'GET_HISTORY_SESSIONS_REQUEST',
  GET_HISTORY_SESSIONS_FULFILLED = 'GET_HISTORY_SESSIONS_FULFILLED',
  GET_HISTORY_SESSIONS_REJECTED = 'GET_HISTORY_SESSIONS_REJECTED',

  EXPORT_HISTORY_SESSION_CSV_REQUEST = 'EXPORT_HISTORY_SESSION_CSV_REQUEST',
  EXPORT_HISTORY_SESSION_CSV_REJECTED = 'EXPORT_HISTORY_SESSION_CSV_REJECTED',

  ACTIVE_CHECKED_USER_REQUEST = 'ACTIVE_CHECKED_USER_REQUEST',
  ACTIVE_CHECKED_USER_FULFILLED = 'ACTIVE_CHECKED_USER_FULFILLED',
  ACTIVE_CHECKED_USER_REJECTED = 'ACTIVE_CHECKED_USER_REJECTED',

  INACTIVE_CHECKED_USER_REQUEST = 'INACTIVE_CHECKED_USER_REQUEST',
  INACTIVE_CHECKED_USER_FULFILLED = 'INACTIVE_CHECKED_USER_FULFILLED',
  INACTIVE_CHECKED_USER_REJECTED = 'INACTIVE_CHECKED_USER_REJECTED',

  REMOVE_ALL_SELECTED_USER_REQUEST = 'REMOVE_ALL_SELECTED_USER_REQUEST',
  REMOVE_ALL_SELECTED_USER_FULFILLED = 'REMOVE_ALL_SELECTED_USER_FULFILLED',
  REMOVE_ALL_SELECTED_USER_REJECTED = 'REMOVE_ALL_SELECTED_USER_REJECTED',

  ENABLE_OR_DISABLE_REMOTE_PROFILE_REQUEST = 'ENABLE_OR_DISABLE_REMOTE_PROFILE_REQUEST',
  ENABLE_OR_DISABLE_REMOTE_PROFILE_FULFILLED = 'ENABLE_OR_DISABLE_REMOTE_PROFILE_FULFILLED',
  ENABLE_OR_DISABLE_REMOTE_PROFILE_REJECTED = 'ENABLE_OR_DISABLE_REMOTE_PROFILE_REJECTED',

  RESET_MFA_USER_REQUEST = 'RESET_MFA_USER_REQUEST',
  RESET_MFA_USER_FULFILLED = 'RESET_MFA_USER_FULFILLED',
  RESET_MFA_USER_REJECTED = 'RESET_MFA_USER_REJECTED',

  SAVE_URL_CONNECTION_REQUEST = 'SAVE_URL_CONNECTION_REQUEST',
  SAVE_URL_CONNECTION_FULFILLED = 'SAVE_URL_CONNECTION_FULFILLED',

  SAVE_CHROME_EXTENSION_REQUEST = 'SAVE_CHROME_EXTENSION_REQUEST',
  SAVE_CHROME_EXTENSION_FULFILLED = 'SAVE_CHROME_EXTENSION_FULFILLED',

  ACTIVE_MFA_TO_ALL_USER_REQUEST = 'ACTIVE_MFA_TO_ALL_USER_REQUEST',
  ACTIVE_MFA_TO_ALL_USER_FULFILLED = 'ACTIVE_MFA_TO_ALL_USER_FULFILLED',
  ACTIVE_MFA_TO_ALL_USER_REJECTED = 'ACTIVE_MFA_TO_ALL_USER_REJECTED',

  SEND_EMAIL_TO_RESET_PASSWORD_REQUEST = 'SEND_EMAIL_TO_RESET_PASSWORD_REQUEST',
  SEND_EMAIL_TO_RESET_PASSWORD_FULFILLED = 'SEND_EMAIL_TO_RESET_PASSWORD_FULFILLED',
  SEND_EMAIL_TO_RESET_PASSWORD_REJECTED = 'SEND_EMAIL_TO_RESET_PASSWORD_REJECTED',

  TEST_OPEN_APPLICATION_REQUEST = 'TEST_OPEN_APPLICATION_REQUEST',
  TEST_OPEN_APPLICATION_FULFILLED = 'TEST_OPEN_APPLICATION_FULFILLED',
  TEST_OPEN_APPLICATION_REJECTED = 'TEST_OPEN_APPLICATION_REJECTED',

  CLEAR_TEST_OPEN_APPLICATION = 'CLEAR_TEST_OPEN_APPLICATION',

  EDIT_MAINTENANCE_REQUEST = 'EDIT_MAINTENANCE_REQUEST',
  EDIT_MAINTENANCE_FULFILLED = 'EDIT_MAINTENANCE_FULFILLED',
  EDIT_MAINTENANCE_REJECTED = 'EDIT_MAINTENANCE_REJECTED',

  GET_MAINTENANCE_REQUEST = 'GET_MAINTENANCE_REQUEST',
  GET_MAINTENANCE_FULFILLED = 'GET_MAINTENANCE_FULFILLED',
  GET_MAINTENANCE_REJECTED = 'GET_MAINTENANCE_REJECTED',
  CLEAR_MAINTENANCE_DATA = 'CLEAR_MAINTENANCE_DATA',

  NEW_CLIENT_REQUEST = 'NEW_CLIENT_REQUEST',
  NEW_CLIENT_FULFILLED = 'NEW_CLIENT_FULFILLED',
  NEW_CLIENT_REJECTED = 'NEW_CLIENT_REJECTED',

  EDIT_CLIENT_REQUEST = 'EDIT_CLIENT_REQUEST',
  EDIT_CLIENT_FULFILLED = 'EDIT_CLIENT_FULFILLED',
  EDIT_CLIENT_REJECTED = 'EDIT_CLIENT_REJECTED',

  NEW_CLONE_CLIENT_REQUEST = ' NEW_CLONE_CLIENT_REQUEST',
  NEW_CLONE_CLIENT_FULFILLED = ' NEW_CLONE_CLIENT_FULFILLED',
  NEW_CLONE_CLIENT_REJECTED = ' NEW_CLONE_CLIENT_REJECTED',

  CREATE_USER_IN_CLIENTE_REQUEST = ' CREATE_USER_IN_CLIENTE_REQUEST',
  CREATE_USER_IN_CLIENTE_FULFILLED = ' CREATE_USER_IN_CLIENTE_FULFILLED',
  CREATE_USER_IN_CLIENTE_REJECTED = ' CREATE_USER_IN_CLIENTE_REJECTED',

  DISABLE_USER_IN_CLIENTE_REQUEST = '  DISABLE_USER_IN_CLIENTE_REQUEST',
  DISABLE_USER_IN_CLIENTE_FULFILLED = '  DISABLE_USER_IN_CLIENTE_FULFILLED',
  DISABLE_USER_IN_CLIENTE_REJECTED = '  DISABLE_USER_IN_CLIENTE_REJECTED',

  ACTIVE_USER_IN_CLIENTE_REQUEST = '  ACTIVE_USER_IN_CLIENTE_REQUEST',
  ACTIVE_USER_IN_CLIENTE_FULFILLED = '  ACTIVE_USER_IN_CLIENTE_FULFILLED',
  ACTIVE_USER_IN_CLIENTE_REJECTED = '  ACTIVE_USER_IN_CLIENTE_REJECTED',

  REMOVE_SESSIONS_REQUEST = ' REMOVE_SESSIONS_REQUEST',
  REMOVE_SESSIONS_FULFILLED = ' REMOVE_SESSIONS_FULFILLED',
  REMOVE_SESSIONS_REJECTED = ' REMOVE_SESSIONS_REJECTED',

  GET_CLIENTS_BY_ID_REQUEST = 'GET_CLIENTS_BY_ID_REQUEST',
  GET_CLIENTS_BY_ID_FULFILLED = 'GET_CLIENTS_BY_ID_FULFILLED',
  GET_CLIENTS_BY_ID_REJECTED = 'GET_CLIENTS_BY_ID_REJECTED',

  NEW_APPLICATION_REQUEST = 'NEW_APPLICATION_REQUEST',
  NEW_APPLICATION_FULFILLED = 'NEW_APPLICATION_FULFILLED',
  NEW_APPLICATION_REJECTED = 'NEW_APPLICATION_REJECTED',

  EDIT_APPLICATION_REQUEST = 'EDIT_APPLICATION_REQUEST',
  EDIT_APPLICATION_FULFILLED = 'EDIT_APPLICATION_FULFILLED',
  EDIT_APPLICATION_REJECTED = 'EDIT_APPLICATION_REJECTED',

  SET_APPLICATION_REQUEST = 'SET_APPLICATION_REQUEST',
  SET_APPLICATION_FULFILLED = 'SET_APPLICATION_FULFILLED',
  SET_APPLICATION_REJECTED = 'SET_APPLICATION_REJECTED',

  GET_APPLICATIONS_REQUEST = 'GET_APPLICATIONS_REQUEST',
  GET_APPLICATIONS_FULFILLED = 'GET_APPLICATIONS_FULFILLED',
  GET_APPLICATIONS_REJECTED = 'GET_APPLICATIONS_REJECTED',

  GET_AVAILABLE_APPLICATIONS_REQUEST = 'GET_AVAILABLE_APPLICATIONS_REQUEST',
  GET_AVAILABLE_APPLICATIONS_FULFILLED = 'GET_AVAILABLE_APPLICATIONS_FULFILLED',
  GET_AVAILABLE_APPLICATIONS_REJECTED = 'GET_AVAILABLE_APPLICATIONS_REJECTED',

  APPLY_CONFIG_APPLICATION_REQUEST = 'CONFIG_APPLICATION_REQUEST',
  APPLY_CONFIG_APPLICATION_FULFILLED = 'CONFIG_APPLICATION_FULFILLED',
  APPLY_CONFIG_APPLICATION_REJECTED = 'CONFIG_APPLICATION_REJECTED',

  REMOVE_CLIENT_REQUEST = 'REMOVE_CLIENT_REQUEST',
  REMOVE_CLIENT_FULFILLED = 'REMOVE_CLIENT_FULFILLED',
  REMOVE_CLIENT_REJECTED = 'REMOVE_CLIENT_REJECTED',

  GET_SESSIONS_CLIENTS_REQUEST = 'GET_SESSIONS_CLIENTS_REQUEST',
  GET_SESSIONS_CLIENTS_FULFILLED = 'GET_SESSIONS_CLIENTS_FULFILLED',
  GET_SESSIONS_CLIENTS_REJECTED = 'GET_SESSIONS_CLIENTS_REJECTED',

  GET_ALL_CLIENTS_USERS_REQUEST = 'GET_ALL_CLIENTS_USERS_REQUEST',
  GET_ALL_CLIENTS_USERS_FULFILLED = 'GET_ALL_CLIENTS_USERS_FULFILLED',
  GET_ALL_CLIENTS_USERS_REJECTED = 'GET_ALL_CLIENTS_USERS_REJECTED',

  REMOVE_CLIENT_USER_REQUEST = 'REMOVE_CLIENT_USER_REQUEST',
  REMOVE_CLIENT_USER_FULFILLED = 'REMOVE_CLIENT_USER_FULFILLED',
  REMOVE_CLIENT_USER_REJECTED = 'REMOVE_CLIENT_USER_REJECTED',

  EDIT_CLIENT_USER_REQUEST = 'EDIT_CLIENT_USER_REQUEST',
  EDIT_CLIENT_USER_FULFILLED = 'EDIT_CLIENT_USER_FULFILLED',
  EDIT_CLIENT_USER_REJECTED = 'EDIT_CLIENT_USER_REJECTED',

  REMOVE_CLIENT_APPLICATION_REQUEST = 'REMOVE_CLIENT_APPLICATION_REQUEST',
  REMOVE_CLIENT_APPLICATION_FULFILLED = 'REMOVE_CLIENT_APPLICATION_FULFILLED',
  REMOVE_CLIENT_APPLICATION_REJECTED = 'REMOVE_CLIENT_APPLICATION_REJECTED',

  REMOVE_CLIENT_WEB_APPLICATION_REQUEST = 'REMOVE_CLIENT_WEB_APPLICATION_REQUEST',
  REMOVE_CLIENT_WEB_APPLICATION_FULFILLED = 'REMOVE_CLIENT_WEB_APPLICATION_FULFILLED',
  REMOVE_CLIENT_WEB_APPLICATION_REJECTED = 'REMOVE_CLIENT_WEB_APPLICATION_REJECTED',

  GET_ACCESS_CONTROL_REQUEST = 'GET_ACCESS_CONTROL_REQUEST',
  GET_ACCESS_CONTROL_FULFILLED = 'GET_ACCESS_CONTROL_FULFILLED',
  GET_ACCESS_CONTROL_REJECTED = 'GET_ACCESS_CONTROL_REJECTED',

  SET_ACCESS_CONTROL_REQUEST = 'SET_ACCESS_CONTROL_REQUEST',
  SET_ACCESS_CONTROL_FULFILLED = 'SET_ACCESS_CONTROL_FULFILLED',
  SET_ACCESS_CONTROL_REJECTED = 'SET_ACCESS_CONTROL_REJECTED',

  EXPORT_USERS_CSV_REQUEST = 'EXPORT_USERS_CSV_REQUEST',
  EXPORT_USERS_CSV_REJECTED = 'EXPORT_USERS_CSV_REJECTED',

  IMPORT_USERS_CSV_REQUEST = 'IMPORT_USERS_CSV_REQUEST',
  IMPORT_USERS_CSV_FULFILLED = 'IMPORT_USERS_CSV_FULFILLED',
  IMPORT_USERS_CSV_REJECTED = 'IMPORT_USERS_CSV_REJECTED',

  IMPORT_CLIENTS_CSV_REQUEST = 'IMPORT_CLIENTS_CSV_REQUEST',
  IMPORT_CLIENTS_CSV_FULFILLED = 'IMPORT_CLIENTS_CSV_FULFILLED',
  IMPORT_CLIENTS_CSV_REJECTED = 'IMPORT_CLIENTS_CSV_REJECTED',

  INACTIVATE_MULTIPLE_APPLICATIONS_REQUEST = '  INACTIVATE_MULTIPLE_APPLICATIONS_REQUEST',
  INACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED = '  INACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED',
  INACTIVATE_MULTIPLE_APPLICATIONS_REJECTED = '  INACTIVATE_MULTIPLE_APPLICATIONS_REJECTED',

  ACTIVATE_MULTIPLE_APPLICATIONS_REQUEST = '  ACTIVATE_MULTIPLE_APPLICATIONS_REQUEST',
  ACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED = '  ACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED',
  ACTIVATE_MULTIPLE_APPLICATIONS_REJECTED = '  ACTIVATE_MULTIPLE_APPLICATIONS_REJECTED',

  REMOVE_MULTIPLE_APPLICATIONS_REQUEST = ' REMOVE_MULTIPLE_APPLICATIONS_REQUEST',
  REMOVE_MULTIPLE_APPLICATIONS_FULFILLED = ' REMOVE_MULTIPLE_APPLICATIONS_FULFILLED',
  REMOVE_MULTIPLE_APPLICATIONS_REJECTED = ' REMOVE_MULTIPLE_APPLICATIONS_REJECTED',

  GET_BLOCK_MULTIPLE_SESSION_REPORT_FULFILLED = 'GET_BLOCK_MULTIPLE_SESSION_REPORT_FULFILLED',
  GET_BLOCK_MULTIPLE_SESSION_REPORT_REJECTED = 'GET_BLOCK_MULTIPLE_SESSION_REPORT_REJECTED',
  GET_BLOCK_MULTIPLE_SESSION_REPORT_REQUEST = 'GET_BLOCK_MULTIPLE_SESSION_REPORT_REQUEST',

  GET_CONNECTION_TYPE_REPORT_FULFILLED = 'GET_CONNECTION_TYPE_REPORT_FULFILLED',
  GET_CONNECTION_TYPE_REPORT_REJECTED = 'GET_CONNECTION_TYPE_REPORT_REJECTED',
  GET_CONNECTION_TYPE_REPORT_REQUEST = 'GET_CONNECTION_TYPE_REPORT_REQUEST',

  GET_MFA_REPORT_FULFILLED = 'GET_MFA_REPORT_FULFILLED',
  GET_MFA_REPORT_REJECTED = 'GET_MFA_REPORT_REJECTED',
  GET_MFA_REPORT_REQUEST = 'GET_MFA_REPORT_REQUEST',

  GET_USE_PROFILE_REPORT_FULFILLED = 'GET_USE_PROFILE_REPORT_FULFILLED',
  GET_USE_PROFILE_REPORT_REJECTED = 'GET_USE_PROFILE_REPORT_REJECTED',
  GET_USE_PROFILE_REPORT_REQUEST = 'GET_USE_PROFILE_REPORT_REQUEST',

  GET_CLIENT_VIRTUALIZER_REPORT_FULFILLED = 'GET_CLIENT_VIRTUALIZER_REPORT_FULFILLED',
  GET_CLIENT_VIRTUALIZER_REPORT_REJECTED = 'GET_CLIENT_VIRTUALIZER_REPORT_REJECTED',
  GET_CLIENT_VIRTUALIZER_REPORT_REQUEST = 'GET_CLIENT_VIRTUALIZER_REPORT_REQUEST',

  GET_ACTIVATE_REPORT_FULFILLED = 'GET_ACTIVATE_REPORT_FULFILLED',
  GET_ACTIVATE_REPORT_REJECTED = 'GET_ACTIVATE_REPORT_REJECTED',
  GET_ACTIVATE_REPORT_REQUEST = 'GET_ACTIVATE_REPORT_REQUEST',

  GET_SALT_REPORT_FULFILLED = 'GET_SALT_REPORT_FULFILLED',
  GET_SALT_REPORT_REJECTED = 'GET_SALT_REPORT_REJECTED',
  GET_SALT_REPORT_REQUEST = 'GET_SALT_REPORT_REQUEST',

  EXPORT_CLIENT_SUMMARY_REQUEST = 'EXPORT_CLIENT_SUMMARY_REQUEST',
  EXPORT_CLIENT_SUMMARY_FULFILLED = 'EXPORT_CLIENT_SUMMARY_FULFILLED',
  EXPORT_CLIENT_SUMMARY_REJECTED = 'EXPORT_CLIENT_SUMMARY_REJECTED',

  EXPORT_USER_SUMMARY_REQUEST = 'EXPORT_USER_SUMMARY_REQUEST',
  EXPORT_USER_SUMMARY_FULFILLED = 'EXPORT_USER_SUMMARY_FULFILLED',
  EXPORT_USER_SUMMARY_REJECTED = 'EXPORT_USER_SUMMARY_REJECTED',

  FORCE_RESET_PASSWORD_SELECTED_USERS_REQUEST = 'FORCE_RESET_PASSWORD_SELECTED_USERS_REQUEST',
  FORCE_RESET_PASSWORD_SELECTED_USERS_FULFILLED = 'FORCE_RESET_PASSWORD_SELECTED_USERS_FULFILLED',
  FORCE_RESET_PASSWORD_SELECTED_USERS_REJECTED = 'FORCE_RESET_PASSWORD_SELECTED_USERS_REJECTED',

  ENABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST = 'ENABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST',
  ENABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED = 'ENABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED',
  ENABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED = 'ENABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED',

  DISABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST = 'DISABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST',
  DISABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED = 'DISABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED',
  DISABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED = 'DISABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED',

  GET_DIGITAL_CERTIFICATES_REQUEST = 'GET_DIGITAL_CERTIFICATES_REQUEST',
  GET_DIGITAL_CERTIFICATES_FULFILLED = 'GET_DIGITAL_CERTIFICATES_FULFILLED',
  GET_DIGITAL_CERTIFICATES_REJECTED = 'GET_DIGITAL_CERTIFICATES_REJECTED',

  CREATE_DIGITAL_CERTIFICATES_REQUEST = 'CREATE_DIGITAL_CERTIFICATES_REQUEST',
  CREATE_DIGITAL_CERTIFICATES_FULFILLED = 'CREATE_DIGITAL_CERTIFICATES_FULFILLED',
  CREATE_DIGITAL_CERTIFICATES_REJECTED = 'CREATE_DIGITAL_CERTIFICATES_REJECTED',

  EDIT_DIGITAL_CERTIFICATES_REQUEST = 'EDIT_DIGITAL_CERTIFICATES_REQUEST',
  EDIT_DIGITAL_CERTIFICATES_FULFILLED = 'EDIT_DIGITAL_CERTIFICATES_FULFILLED',
  EDIT_DIGITAL_CERTIFICATES_REJECTED = 'EDIT_DIGITAL_CERTIFICATES_REJECTED',

  DELETE_DIGITAL_CERTIFICATES_REQUEST = 'DELETE_DIGITAL_CERTIFICATES_REQUEST',
  DELETE_DIGITAL_CERTIFICATES_FULFILLED = 'DELETE_DIGITAL_CERTIFICATES_FULFILLED',
  DELETE_DIGITAL_CERTIFICATES_REJECTED = 'DELETE_DIGITAL_CERTIFICATES_REJECTED',
}

export default Types;
